//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import _ from 'lodash';
import classnames from 'classnames';
import { Input, InputTypes } from 'common/components/core/input';
import { IconButton } from 'react-toolbox/lib/button';
import MlFontIcon from 'common/components/core/font_icon/MlFontIcon';
import I18nHelper from 'common/helpers/I18nHelper';
import enhanceWithClickOutside from 'common/components/core/util/HandleOutsideClick';

import SearchInputTheme from './SearchInput.scss';

type Props = {
    searchInput?: ?string,
    placeholder: string,
    inputType?: string,
    theme: Object,
    className?: ?string,
    onSearchInputChange: string => void,
    autoFocus: boolean,
    onFocus: () => void,
    onClear?: () => void
};

type State = {
    searchInput: string
};

const nsTranslate = I18nHelper.getTranslate('translations');

class SearchInput extends React.PureComponent<Props, State> {
    state: State;

    static defaultProps = {
        onClear: () => {},
        placeholder: nsTranslate('search')
    };

    constructor(props: Props) {
        super(props);
        this.state = {
            searchInput: props.searchInput || ''
        };
        this.onSearchCallback = _.debounce(props.onSearchInputChange, 150);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.searchInput !== this.props.searchInput) {
            this.setState({ searchInput: this.props.searchInput });
        }
    }

    onSearchInputChange = searchInput => {
        this.setState({ searchInput });
        this.onSearchCallback(searchInput);
    };

    onClearSearchInput = () => {
        this.setState({ searchInput: '' });
        this.onSearchCallback('');
        this.props.onClear();
    };

    renderSearchClearIcon = () => {
        const { searchInput } = this.state;
        const { theme } = this.props;
        const searchClearIcon = (
            <IconButton
                className={theme.rightIconButton}
                ripple={false}
                onClick={this.onClearSearchInput}
                icon="clear"
            />
        );
        return searchInput?.length && searchClearIcon;
    };
    render() {
        const {
            placeholder,
            theme,
            onFocus,
            className,
            inputType = InputTypes.NoBorder,
            ...others
        } = this.props;
        const { searchInput } = this.state;
        return (
            <Input
                {...others}
                floating={false}
                value={searchInput}
                className={classnames([className], theme.searchInput)}
                leftIcon={<MlFontIcon iconClass="search" />}
                rightIcon={this.renderSearchClearIcon()}
                type="text"
                inputType={inputType}
                theme={theme}
                placeholder={placeholder}
                onChange={this.onSearchInputChange}
                onFocus={onFocus}
            />
        );
    }
}

const ThemedSearchInput = themr('SearchInput', SearchInputTheme, {
    withRef: true
})(SearchInput);

const EnhancedSearchInput = enhanceWithClickOutside(ThemedSearchInput);
export { EnhancedSearchInput };
export default ThemedSearchInput;
